module.exports = __webpack_public_path__ + "img/moderation_liveflamingo.7245c87c.svg";